/**
 * Geometry mosaic icon for "Math Tools".
 * Triangle + square + circle + π — conveys geometry & numbers.
 */
export default function MathIcon({ size = 32, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Triangle (top-left) */}
      <polygon
        points="8,3 14,13 2,13"
        stroke="#db2777"
        strokeWidth="2"
        strokeLinejoin="round"
        fill="none"
      />
      {/* Square (top-right) */}
      <rect
        x="18"
        y="3"
        width="11"
        height="11"
        rx="1.5"
        stroke="#0284c7"
        strokeWidth="2"
        fill="none"
      />
      {/* Circle (bottom-left) */}
      <circle
        cx="8"
        cy="24"
        r="6"
        stroke="#16a34a"
        strokeWidth="2"
        fill="none"
      />
      {/* π symbol (bottom-right) */}
      <text
        x="20"
        y="29"
        fontFamily="'Fredoka', serif"
        fontSize="14"
        fontWeight="700"
        fill="#d97706"
      >π</text>
    </svg>
  );
}
